import SectionHeading from "@/components/base/SectionHeading";
import StoryCard from "@/components/feature/StoryCard";
import { stories } from "@/mocks/stories";

export default function LatestStories() {
  const [lead, ...rest] = stories.slice(1);
  const gridStories = rest.slice(0, 4);
  const ranking = [...stories].sort((a, b) => b.heat - a.heat).slice(0, 5);

  return (
    <section className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="最新爆料"
        title="刚刚被摆到桌面上的线索"
        desc="按时间排列的口述型稿件，每篇都标注了信源类型与核实程度。"
        actionHref="/stories"
        actionLabel="查看全部"
      />

      <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
        <div className="lg:col-span-8">
          <div className="reveal">
            <StoryCard story={lead} variant="wide" />
          </div>
          <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2">
            {gridStories.map((story) => (
              <div className="reveal" key={story.id}>
                <StoryCard story={story} />
              </div>
            ))}
          </div>
        </div>

        <aside className="lg:col-span-4">
          <div className="reveal rounded-lg border border-background-200 bg-background-100 p-5">
            <div className="flex items-center justify-between">
              <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-fire-line text-primary-600" aria-hidden="true"></i>
                热度榜
              </h3>
              <span className="text-xs font-label text-foreground-500">近 30 天</span>
            </div>
            <div className="mt-3">
              {ranking.map((story, i) => (
                <StoryCard key={story.id} story={story} variant="compact" index={i} />
              ))}
            </div>
            <p className="mt-4 rounded-md bg-accent-100 px-3 py-2.5 text-xs leading-relaxed text-accent-900">
              <i className="ri-information-line mr-1" aria-hidden="true"></i>
              热度由阅读、讨论与转发综合计算，不代表内容立场。
            </p>
          </div>
        </aside>
      </div>
    </section>
  );
}